<ion-card>
  <ion-card-header>
    <ion-card-title>Tömeges kiküldés</ion-card-title>
    <ion-card-subtitle>
      Öt lépés: összeállítás → dokumentum → aláírás → iktatás → kiküldés. Mindegyik
      újrafuttatható, és tételesen látszik, ki akadt el – egy hibás címzett nem
      állítja meg a többit.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-segment [(ngModel)]="nezet" mode="ios">
      <ion-segment-button value="kotegek"><ion-label>Kötegek</ion-label></ion-segment-button>
      <ion-segment-button value="uj"><ion-label>Új köteg</ion-label></ion-segment-button>
    </ion-segment>

    <!-- ÚJ KÖTEG -->
    <ng-container *ngIf="nezet === 'uj'">
      <div class="ikt-szamok">
        <div class="ikt-szam" *ngFor="let f of forrasok"
             [class.figyelem]="f.kulcs === uj.forras"
             (click)="uj.forras = f.kulcs; tetelekBetolt()">
          <div class="ertek">{{ f.kikuldheto < 0 ? '–' : f.kikuldheto }}</div>
          <div class="cimke">{{ f.nev }}</div>
        </div>
      </div>

      <div class="ikt-fejsor">
        <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="uj.ev"
                   (ionBlur)="tetelekBetolt()" style="max-width:110px"></ion-input>
        <ion-input label="Hónap" label-placement="stacked" type="number" [(ngModel)]="uj.ho"
                   (ionBlur)="tetelekBetolt()" style="max-width:100px"></ion-input>
        <ion-input label="Köteg neve" label-placement="stacked" [(ngModel)]="uj.nev"
                   placeholder="pl. 2026. augusztus havi bérjegyzék" style="max-width:280px"></ion-input>
        <ion-select label="Csatorna" label-placement="stacked" interface="popover" [(ngModel)]="uj.csatorna">
          <ion-select-option *ngFor="let c of CSATORNAK" [value]="c.kulcs">{{ c.nev }}</ion-select-option>
        </ion-select>
        <ion-select label="Iktatókönyv" label-placement="stacked" interface="popover"
                    [(ngModel)]="uj.konyv" [disabled]="uj.iktatas_nelkul">
          <ion-select-option *ngFor="let k of konyvek" [value]="k.id">{{ k.jel }} – {{ k.nev }}</ion-select-option>
        </ion-select>
        <!--  NEM MINDEN KIKÜLDÉS IRAT. A bérjegyzék jellemzően nem iktatandó; az
              iktatókönyv kötelezővé tétele miatt eddig „gyűjtő" könyvet kellett nyitni
              hozzá, és a postakönyv tele lett nem kívánt iratszámokkal. -->
        <ion-item lines="none" class="iktatas-nelkul">
          <ion-checkbox slot="start" [checked]="uj.iktatas_nelkul"
                        (ionChange)="uj.iktatas_nelkul = $event.detail.checked"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            <b>Iktatás nélkül</b>
            <br><small>A küldemény nem kap iratszámot, és az iktatás lépés kimarad. A
            postakönyvbe attól még bekerül, tehát visszakereshető marad.</small>
            <!--  A visszajövő igazolás ALSZÁMOT az eredeti irat ügyiratára kap – ha nincs
                  irat, nincs mire. A kézbesítés attól még végigkövethető, de ezt a
                  döntés pillanatában kell tudni, nem hetekkel később. -->
            <br><small *ngIf="uj.csatorna === 'bksz' && uj.iktatas_nelkul" class="figyelem">
              Hivatali kapunál ilyenkor a visszajövő <b>feladási és letöltési igazolás nem
              kap alszámot</b> (nincs mire) – a küldemény állapota és a bizonyító PDF a
              <b>Kézbesítési naplóban</b> így is végigkövethető.
            </small>
          </ion-label>
        </ion-item>
        <ion-select class="hosszu-ertek" label="Irattári tétel" label-placement="stacked" interface="popover" [interfaceOptions]="{ cssClass: 'hosszu-opciok' }" [(ngModel)]="uj.tetelszam">
          <ion-select-option value="">– nincs –</ion-select-option>
          <ion-select-option *ngFor="let t of terv" [value]="t.tetelszam">{{ t.tetelszam }} – {{ t.megnevezes }}</ion-select-option>
        </ion-select>
        <ion-select label="Ügyintéző" label-placement="stacked" interface="popover" [(ngModel)]="uj.ugyintezo">
          <ion-select-option *ngFor="let u of ugyintezok" [value]="u.azonosito">{{ u.nev }}</ion-select-option>
        </ion-select>
      </div>

      <!-- ══════════ EGYEDI KIKÜLDÉS ══════════
           Egy címzett, névre keresve. A sorrend itt fordított: előbb az iktatás adja a
           számot, és AZ kerül rá a dokumentumra határozatszámként – egy már aláírt
           PDF-be utólag nem lehet beleírni. -->
      <ng-container *ngIf="egyediMod">
        <ion-note color="medium" style="display:block;margin-bottom:8px;font-size:.82rem">
          Keresd meg a címzettet a nevével: <b>munkatárs</b>, <b>tanuló</b>, <b>gondviselő</b>
          vagy a partnertörzs. A köteg létrehozása után a sorrend:
          <b>iktatás → dokumentum → aláírás → küldés</b> — így az iktatószám
          rákerülhet a dokumentumra határozatszámként (<code>{{ '{{' }} hatarozatszam {{ '}}' }}</code>).
        </ion-note>

        <div class="ikt-cimzett-valaszto">
          <ion-input label="Címzett keresése" label-placement="stacked" fill="outline"
                     placeholder="Név, azonosító vagy e-mail (min. 2 karakter)"
                     [(ngModel)]="szemelyKereses" (ionInput)="szemelyKeres()"></ion-input>

          <div class="ikt-talalatok" *ngIf="szemelyTalalatok.length">
            <div class="ikt-talalat" *ngFor="let x of szemelyTalalatok" (click)="szemelyHozzaad(x)">
              <span>
                <ion-badge color="medium">{{ KOR_NEV[x.tipus] || x.tipus }}</ion-badge>
                {{ x.nev }}<span class="alsor" *ngIf="x.reszlet"> · {{ x.reszlet }}</span>
                <span class="alsor" *ngIf="x.email"> · {{ x.email }}</span>
              </span>
              <ion-icon name="add-circle-outline"></ion-icon>
            </div>
          </div>

          <div class="ikt-valasztottak" *ngIf="valasztottak.length">
            <span class="ikt-chip" *ngFor="let x of valasztottak">
              <b>{{ KOR_NEV[x.tipus] || x.tipus }}:</b> {{ x.nev }}
              <span class="mail" *ngIf="x.email">· {{ x.email }}</span>
              <span class="mail nincs" *ngIf="!x.email">· nincs e-mail</span>
              <span class="x" (click)="szemelyKivesz(x)">×</span>
            </span>
          </div>

          <!--  Az e-mail csatorna cím nélkül nem megy ki: ezt a köteg összeállításakor
                mondjuk meg, ne a küldés lépésénél derüljön ki. -->
          <ion-note color="warning" *ngIf="uj.csatorna === 'email' && emailHianyzik"
                    style="display:block;font-size:.8rem">
            {{ emailHianyzik }} címzettnek nincs e-mail címe – nekik a küldés
            e-mailen nem fog menni. Válassz másik csatornát, vagy vedd fel a címet a törzsadatban.
          </ion-note>
        </div>
      </ng-container>

      <!-- ══════════ ZIP-BŐL ══════════ -->
      <ng-container *ngIf="zipMod">
        <ion-note color="medium" style="display:block;margin-bottom:8px;font-size:.82rem">
          Töltsd fel a kész PDF-eket <b>egy ZIP-ben</b> (pl. a bérprogramból exportált bérjegyzékek).
          A rendszer a <b>fájlnevekben lévő név</b> alapján osztja szét őket a dolgozók között —
          a „Kovács Béla" és a „Bela_Kovacs" alak is jó, mappákban is lehetnek.
          Amihez nem talál egyértelmű dolgozót, azt <b>kihagyja</b>, és megmondja, melyiket.
        </ion-note>

        <div class="ikt-zip">
          <label class="ikt-zip-gomb">
            <ion-icon name="archive-outline"></ion-icon>
            {{ zipFajl ? zipFajl.name : 'ZIP kiválasztása' }}
            <input type="file" accept=".zip,application/zip" (change)="zipValaszt($event)" hidden />
          </label>
          <ion-button size="small" (click)="zipFeltoltes()" [disabled]="!zipFajl || zipFut">
            {{ zipFut ? 'Feldolgozás…' : 'Feltöltés és szétosztás' }}
          </ion-button>
        </div>

        <div class="ikt-zip-eredmeny" *ngIf="zipEredmeny">
          <div class="ok" *ngIf="zipEredmeny.felvett?.length">
            <b>{{ zipEredmeny.felvett.length }} dokumentum a kötegben:</b>
            <div *ngFor="let f of zipEredmeny.felvett">
              {{ f.fajl }} → <b>{{ f.dolgozo }}</b>
              <span class="halvany" *ngIf="f.email"> · {{ f.email }}</span>
              <span class="halvany" *ngIf="!f.email"> · nincs e-mail címe</span>
            </div>
          </div>
          <!--  A kimaradt fájl nem mellékes: a dolgozó nem kapja meg a bérjegyzékét.
                Ezért fájlnévvel és okkal soroljuk fel. -->
          <div class="baj" *ngIf="zipEredmeny.kihagyva?.length">
            <b>{{ zipEredmeny.kihagyva.length }} fájl kimaradt:</b>
            <div *ngFor="let k of zipEredmeny.kihagyva">{{ k.fajl }} — {{ k.ok }}</div>
          </div>
        </div>
      </ng-container>

      <!--  ══════════ KIHEZ KÖSSÜK? ══════════
            Nem hiba, hanem kérdés. A tömeges feladás korábban minden címzetthez ÚJ
            partnert hozott létre, és a duplikátumon nem volt kapcsolati kód – a kézzel
            beírt kód így „eltűnt", a hivatali kapus kiküldés pedig elakadt. -->
      <div class="ikt-partner-kerdes" *ngIf="partnerKerdesek.length">
        <b>{{ partnerKerdesek.length }} címzett nincs a partnertörzsben.</b>
        Kösd őket a meglévő partnerhez, vagy engedd, hogy újat hozzunk létre –
        utána nyomd meg újra a köteg gombot.
        <div class="sor" *ngFor="let k of partnerKerdesek">
          <span class="nev">{{ k.nev }}<span class="halvany" *ngIf="k.email"> · {{ k.email }}</span></span>
          <ion-select interface="popover" fill="outline" [value]="partnerValasztott(k)"
                      (ionChange)="partnerValasztas(k, $event.detail.value)">
            <ion-select-option *ngFor="let j of k.javaslatok" [value]="j.id">
              {{ j.nev }} <span *ngIf="j.reszlet">({{ j.reszlet }})</span>
            </ion-select-option>
            <ion-select-option value="__uj">Új partner létrehozása</ion-select-option>
          </ion-select>
          <span class="halvany" *ngIf="!k.javaslatok?.length">nincs hasonló a törzsben</span>
        </div>
        <ion-button size="small" fill="clear" (click)="partnerKerdesMegse()">Mégsem</ion-button>
      </div>

      <div class="ikt-fejsor">
        <ion-button size="small" fill="outline" *ngIf="!egyediMod && !zipMod" (click)="tetelekBetolt()">Címzettek betöltése</ion-button>
        <ion-button size="small" fill="outline" *ngIf="!egyediMod && !zipMod" (click)="mindet()">Mindet kijelöl</ion-button>
        <ion-button size="small" *ngIf="!zipMod" (click)="kotegLetrehoz()"
                    [disabled]="egyediMod ? !valasztottak.length : !kijelolt.size">
          {{ egyediMod ? 'Kiküldés indítása (' + valasztottak.length + ')' : 'Köteg létrehozása (' + kijelolt.size + ')' }}
        </ion-button>
      </div>

      <ion-note color="medium" *ngIf="uj.forras === 'riport'" style="display:block;margin-bottom:8px;font-size:.82rem">
        A bérjegyzék PDF-jét a <b>Riportok</b> képernyő állítja elő és tölti fel a kötegbe –
        itt csak a címzetteket állítod össze, a dokumentumot nem számoljuk újra.
      </ion-note>

      <div class="ikt-tabla-doboz" *ngIf="tetelek.length && !egyediMod && !zipMod">
        <table class="ikt-tabla">
          <thead>
            <tr><th style="width:36px"></th><th>Címzett</th><th>E-mail</th><th>Postafiók</th>
                <th>Kézbesíthetőség</th><th>Állapot</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tetelek" [class.ervenytelen]="t.mar_kikuldve">
              <td><ion-checkbox [checked]="kivan(t)" [disabled]="!!t.akadaly || t.mar_kikuldve"
                                (ionChange)="valt(t, $event.detail.checked)"></ion-checkbox></td>
              <td>{{ t.szemely }}</td>
              <td>{{ t.email || '—' }}</td>
              <td>{{ t.kapu_tipus || '—' }}</td>
              <td>
                <ion-badge color="success" *ngIf="!kapuGond(t) && !t.akadaly">rendben</ion-badge>
                <ion-badge color="warning" *ngIf="kapuGond(t)">hiányzik: {{ kapuGond(t) }}</ion-badge>
                <ion-badge color="danger" *ngIf="t.akadaly">{{ t.akadaly }}</ion-badge>
              </td>
              <td><ion-badge color="medium" *ngIf="t.mar_kikuldve">már kiküldve</ion-badge></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- KÖTEGEK -->
    <ng-container *ngIf="nezet === 'kotegek'">
      <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>
      <div class="ikt-tabla-doboz" *ngIf="!betoltes">
        <table class="ikt-tabla">
          <thead>
            <tr><th>Köteg</th><th>Csatorna</th><th class="szam">Tétel</th><th class="szam">Aláírt</th>
                <th class="szam">Iktatott</th><th class="szam">Kiküldött</th><th class="szam">Hibás</th>
                <th>Állapot</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of kotegek">
              <td><b>{{ k.nev }}</b>
                <div style="font-size:.76rem;color:var(--ion-color-medium-shade,#6b7280)">
                  {{ k.letrehozva | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </td>
              <td>{{ k.csatorna }}</td>
              <td class="szam">{{ k.tetel_db }}</td>
              <td class="szam">{{ k.alairt_db }}</td>
              <td class="szam">{{ k.iktatott_db }}</td>
              <td class="szam">{{ k.kuldott_db }}</td>
              <td class="szam">
                <ion-badge color="danger" *ngIf="k.hibas_db > 0">{{ k.hibas_db }}</ion-badge>
                <span *ngIf="!k.hibas_db">0</span>
              </td>
              <td><ion-badge color="medium">{{ k.allapot }}</ion-badge></td>
              <td><ion-button size="small" fill="clear" (click)="megnyit(k)">Megnyitás</ion-button></td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!kotegek.length">Még nincs köteg.</div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>

<!-- MEGNYITOTT KÖTEG -->
<ion-card *ngIf="megnyitott">
  <ion-card-header>
    <ion-card-title>{{ megnyitott.koteg.nev }}</ion-card-title>
    <ion-card-subtitle>
      Csatorna: {{ megnyitott.koteg.csatorna }} · állapot: {{ megnyitott.koteg.allapot }}
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <!--  A LÉPÉSEK SORRENDJE. A „2. Dokumentum" nem gomb, hanem tételenkénti feltöltés a
          táblázatban – bérjegyzéknél a Riportok képernyő, ZIP-nél a kicsomagolás tölti fel,
          egyedi kiküldésnél te. Enélkül eddig úgy tűnt, hogy ez a lépés nem is létezik. -->
    <ion-note color="medium" style="display:block;margin-bottom:8px;font-size:.82rem">
      <b>2. Dokumentum:</b> a táblázat utolsó oszlopában, tételenként tölthető fel a PDF.
      Aláírás után már nem cserélhető.
    </ion-note>
    <div class="ikt-gombsor">
      <ion-button size="small" color="tertiary" (click)="lepes('alairas')" [disabled]="!!lepesFut">
        <ion-icon slot="start" name="create-outline"></ion-icon>
        {{ lepesFut === 'alairas' ? 'Aláírás…' : '3. Aláírás' }}
      </ion-button>
      <ion-button size="small" color="primary" (click)="lepes('iktatas')" [disabled]="!!lepesFut">
        <ion-icon slot="start" name="book-outline"></ion-icon>
        {{ lepesFut === 'iktatas' ? 'Iktatás…' : '4. Iktatás' }}
      </ion-button>
      <ion-button size="small" color="success" (click)="lepes('kuldes')" [disabled]="!!lepesFut">
        <ion-icon slot="start" name="send-outline"></ion-icon>
        {{ lepesFut === 'kuldes' ? 'Kiküldés…' : '5. Kiküldés' }}
      </ion-button>
      <ion-button size="small" fill="clear" (click)="megnyitott = null">Bezárás</ion-button>
    </div>

    <div class="ikt-tabla-doboz">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Címzett</th><th>Iktatószám</th><th>Dokumentum</th><th>Állapot</th>
              <th>Hiba</th><th class="szam">Feladva</th><th></th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of megnyitott.tetelek">
            <td>{{ t.cimzett_nev }}</td>
            <td class="iktszam">{{ t.iktatoszam || '—' }}</td>
            <td>
              <ion-icon name="document-outline" *ngIf="t.dokumentum_path" color="medium" title="feltöltve"></ion-icon>
              <ion-icon name="ribbon-outline" *ngIf="t.alairt_path" color="success" title="aláírva"></ion-icon>
              <span *ngIf="!t.dokumentum_path && !t.alairt_path">—</span>
            </td>
            <td><ion-badge [color]="tetelSzin(t)">{{ t.statusz }}</ion-badge></td>
            <td style="font-size:.78rem;color:var(--ion-color-danger,#c00)">{{ t.hiba || '' }}</td>
            <td class="szam">{{ t.feladva || '—' }}</td>
            <td class="ikt-tetel-gombok">
              <ion-button size="small" fill="clear" *ngIf="t.alairt_path || t.dokumentum_path"
                          (click)="letoltes(t)">Megnyitás</ion-button>
              <!--  DOKUMENTUM FELTÖLTÉSE. A bérjegyzéknél a Riportok képernyő, a ZIP-esnél a
                    kicsomagolás teszi meg; az egyedi kiküldésnél a felhasználó – és eddig
                    nem volt hol. Aláírt tételnél már nincs gomb: az aláírás arra a PDF-re
                    szól, ami kimegy. -->
              <label class="ikt-tetel-feltolt" *ngIf="!t.alairt_path">
                <ion-icon name="cloud-upload-outline"></ion-icon>
                {{ tetelFeltoltFut === t.id ? 'Feltöltés…'
                   : (t.dokumentum_path ? 'Csere' : 'Dokumentum') }}
                <input type="file" accept="application/pdf,.pdf" hidden
                       (change)="tetelFajl(t, $event)" [disabled]="tetelFeltoltFut === t.id" />
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ion-card-content>
</ion-card>
